import { ADMIN_EMAIL, COMPANY_NAME, type ParticipantNote } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { HocuspocusDebugMenu } from '../../components/tiptap/HocuspocusDebugMenu';
import type { HocuspocusState } from '../../components/tiptap/hooks/useHocuspocusProvider';
import { SaveStatusIndicator } from '../../components/tiptap/SaveStatusIndicator';
import { UserStatusIndicator } from '../../components/tiptap/UserStatusIndicator';
import { UserDescription } from '../../components/user/UserDescription';
import { ManageParticipantNoteLabelsControl } from './ManageParticipantNoteLabelsControl';
import { ParticipantNoteActionMenu } from './ParticipantNoteActionMenu';

interface Props {
  editor: Editor;
  state: HocuspocusState;
  participantNote: ParticipantNote;
  isDisabled?: boolean;
  onDelete: () => void;
}

export const ParticipantNoteTitleBar = (props: Props) => {
  const { participantNote, editor, state, isDisabled, onDelete } = props;

  return (
    <ChakraV3.Stack gap={4} mt={4}>
      <ChakraV3.HStack fontSize='sm' gap={4}>
        <UserDescription
          name={participantNote.user?.name ?? COMPANY_NAME}
          secondary={participantNote.user?.email ?? ADMIN_EMAIL}
          picture={participantNote?.user?.picture}
        />

        <ChakraV3.Stack w='full' alignSelf='center'>
          <ManageParticipantNoteLabelsControl
            participantNote={participantNote}
            isDisabled={isDisabled}
          />
        </ChakraV3.Stack>

        <ChakraV3.Spacer />
        <ChakraV3.HStack flexShrink={0}>
          <SaveStatusIndicator state={state} />
          <UserStatusIndicator editor={editor} state={state} />
          <HocuspocusDebugMenu variant='outline' size='sm' />
          <ParticipantNoteActionMenu
            participantNote={participantNote}
            variant='outline'
            size='sm'
            disabled={isDisabled}
            onDelete={onDelete}
          />
        </ChakraV3.HStack>
      </ChakraV3.HStack>
    </ChakraV3.Stack>
  );
};
